import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface GenericListItem {
    id: number;
    name: string;
}

const ReportCustomerPricelist = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);
    const [pricelistOptions, setPricelistOptions] = React.useState<GenericListItem[]>([]);
    const [pricelistTierId, setPricelistTierId] = React.useState(-1);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                axios.get('api/Customer/GetCustomerPricelistTiers?SubId=' + user.sub, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    setPricelistOptions(res.data);
                    setLoading(false);
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (pricelistTierId < 0) {
            formIsValid = false;
            errorList["pricelistTierId"] = "Price List is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data
        if (validate()) {
            runRpt();
        }
    }
 
    const runRpt = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        axios('api/Report/ExportCustomerPriceListTierReportData?subId=' + user.sub + '&PriceListTierId=' + pricelistTierId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');

            var fileheader = res.headers["content-disposition"];
            var filename = "Customers with Pricelist.xlsx";
            if (fileheader) {
                filename = fileheader.split('filename=')[1].split(';')[0];
                filename = filename.replaceAll('"', '');
            }

            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const renderDetails = (
        <div>
            <div className="marginBottom20">
                <h1>Customers with Pricelist Report</h1>
                <div>This report will show all customers setup with the selected pricelist.</div>
                <div>Note: Tier 1 won't show many customers as this is the default pricelist so doesn't need to be selected.</div>
            </div>
            <div>
                <label className="input-group" htmlFor="pricelistTierId">
                    <span className="label">Pricelist</span>
                    <select className="select" id="pricelistTierId" name="pricelistTierId" value={pricelistTierId} onChange={(e) => setPricelistTierId(Number(e.target.value))}>
                        <option defaultValue="-1" value="-1"></option>
                        {pricelistOptions.map(item =>
                            <option key={item.id} value={item.id}>{item.name}</option>
                        )};
                    </select>
                </label>

                <span className={errors["pricelistTierId"] ? "label errors marginLeftLabel" : "hidden"}>{errors["pricelistTierId"]}</span>
            </div>
            <div>
                <button className="defaultbutton marginLeftLabel" type='button' onClick={runReport}>Run Report</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportCustomerPricelist;